<template>
  <v-dialog v-model="display" width="600">
    <!-- Allow the usual Vuetify activator syntax from outside -->
    <template #activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs"/>
    </template>
    <v-card>
      <v-card-title>
        <slot name="title">
          {{ $t('delete_route') }}
        </slot>
      </v-card-title>
      <v-card-text>
        <p>{{ $t('to_delete_this_route')}}</p>
        <v-textarea
          v-model.trim="deleteRouteNote"
          rows="3"
          outlined
          :error-messages="errors"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="close" :disabled="updating">
          {{ this.$t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="handleOk" :loading="updating">
          {{ this.$t('ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ValidationMixin from '@/components/mixins/ValidationMixin'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'DeleteRouteDialog',
  mixins: [
    CurrentUserMixin,
    ValidationMixin
  ],
  props: {
    route: Object
  },
  validations: {
    deleteRouteNote: {
      required,
      minLength: minLength(3)
    }
  },
  data () {
    return {
      display: false,
      updating: false,
      deleteRouteNote: '',
      deletingRoute: false
    }
  },
  computed: {
    errors () {
      return this.validationErrors([{
        prop: this.$v.deleteRouteNote,
        message: this.$t('delete_route_reason_required')
      }])
    }
  },
  methods: {
    open () {
      this.display = true
    },
    close () {
      this.display = false
    },
    async handleOk () {
      this.$v.$touch()
      if (this.$v.$invalid) return false
      this.updating = true
      try {
        // Delete the route and create the new note record
        await this.route.destroy()
        await this.$orm('Note')
          .createOrUpdate({
            resource: 'route',
            entity_id: this.route.id,
            user_id: this.user.id,
            note: this.deleteRouteNote,
            context: 'frontend/form/route'
          })
        this.$router.push('/routes', () => {
          this.$store.dispatch(
            'globalMessagingModule/showSuccessFlashBanner',
            `${this.$tc('route')} ${this.$t('generic_delete_success')}`
          )
        })
      } catch (error) {
        this.updating = false
        this.display = false
        this.handleError(error)
      }
    }
  }
}
</script>

<style scoped>

</style>
